/* eslint-disable no-restricted-syntax */
import { defaultQuestions } from '../constants/defaultQuestions';
import {
  defaultResponses,
  funnyResponses,
} from '../constants/defaultResponses';

export const getMockResponse = (question: string): string => {
  const normalizedQuestion = question.trim();

  for (const [entity, questions] of Object.entries(defaultQuestions)) {
    const questionIndex = questions.findIndex((q) => q === normalizedQuestion);

    if (questionIndex !== -1) {
      return defaultResponses[entity as keyof typeof defaultResponses][
        questionIndex
      ];
    }
  }

  return funnyResponses[Math.floor(Math.random() * funnyResponses.length)];
};
